import { deleteTenantData } from "@/Api/tenants";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Loader, Trash } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export const DeleteTenantBtn = ({idTenant, updateFront, nameTenant}) => {
    const [isLoad, setIsLoad] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const onDelete = async () => {
        setIsLoad(prev => !prev);

        const { ok } = await deleteTenantData(idTenant);
        if(!ok) {
            setIsLoad(prev => !prev);
            setIsOpen(false);
            return;
        };
        
        updateFront(prev => {
            return {
                ...prev,
                data: [...prev.data.filter( tenant => tenant.uuid !== idTenant )],
            };
        });
        
        toast(`${nameTenant} foi excluído(a)!`)
        setIsLoad(prev => !prev);
        setIsOpen(prev => !prev);
    };

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                <Button
                    variant="ghost"
                    size="icon"
                    className="mx-1 size-7 p-0 hover:bg-stone-950/10"
                    >
                        <Trash className="size-5 !text-red-500" />
                </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>Excluir?</DialogTitle>
                    <DialogDescription>
                        Deseja mesmo 
                        <span className="text-red-500 font-bold"> excluir </span> 
                        <span>{nameTenant}</span>?
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button className="bg-red-800 flex gap-1"
                            onClick={onDelete}
                            disabled={isLoad}
                    >
                        {isLoad && <Loader className="animate-spin size-4" /> }
                        Sim
                    </Button>
                    <Button className="bg-green-800"
                            disabled={isLoad} 
                            onClick={() => setIsOpen(prev => !prev)} 
                        >Não</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};